var QuickviewRox = function(){ 
    
    this.bindEvent = function(self){
    	QuickViewSummary.prototype.bindEvent.apply(self, [this]);
		$(".quickView-rox .prescriptionButton").off(self.eventType).on(self.eventType, {"self": self}, self.changePrescription);
	};
    this.changePrescription = function(e){
    	var self = e.data.self;
    	if($(e.currentTarget).hasClass("prescriptionButton")){
	    	self.productSKU = $(e.currentTarget).find(".prescription-val").val();
	        //var lensTypeVal = $("#D_PDP_Prod_PolarSelection .dd-option-selected .dd-option-ispolarized").val();
	        self.selectedProductData = self.product[1][self.productSKU];
            
            /****override addTobagFlag of selectedData with the frame addToBagFlag***/
            self.selectedProductData.addToBagFlag = self.product[1][self.selectedProductData.frameCatentryId].addToBagFlag;
            self.updateROXPrices();

            self.layoutRender(self.selectedProductData,"","");
		    self.bindEvent(self);
		    self.checkifAddedToWishList(self.selectedProductData.catentryId);
        }
        return false;
    };
    this.checkifAddedToWishList  = function(defaultCatId){
    	var self = this;
    	var wishListCatentryIds = $("#wishListCatentryIds").val(); 
    	
    	var catEntryIds = self.product[1][defaultCatId].frameCatentryId;
        catEntryIds += "_"+ self.product[1][defaultCatId].catentryId;
        var services = self.product[1][defaultCatId].mandatoryServices;
        var servicesArr = services.split(",");
        if(servicesArr.length == 1){
            catEntryIds += "_" + self.product[1][defaultCatId].mandatoryServices;
        }
        else{
            for(i=0; i<servicesArr.length; i++){
                catEntryIds += "_"+servicesArr[i];
            }
        }


    	if(undefined !== wishListCatentryIds){
	 	wishListCatentryIds = wishListCatentryIds.replace("[","").replace("]","").split(",");
    	}
    	$.each(wishListCatentryIds, function(itr,catEntryId){
	    	if($.trim(catEntryIds) == $.trim(catEntryId))
		 	{
	    		if($("#D_QuickView_Prod .wcs-fav-container").find("span").hasClass("wcs-quickbuy-favourite")) {
                    $("#D_QuickView_Prod .wcs-fav-container").find("span").removeClass("wcs-quickbuy-favourite").addClass("wcs-quickbuy-tickMark");
                    $("#D_QuickView_Prod .wcs-fav-container").find("a").addClass("wcs-favourite-added").text($("#D_QuickView_Prod .wcs-fav-container").find("a").data("save-label"));
                 }
	         return;
	        }
		});
    };
    this.mergeLensframeData = function(){
        var selectedFrame = $("#frameCatentryId").val();
        /**Using JSON parse n reverse remove the reference to the window.pdpdata**/
        var frameData = JSON.parse(JSON.stringify(quickviewRox.product[1][selectedFrame]));
        var lensdata  = JSON.parse(JSON.stringify(quickviewRox.product[1][quickviewRox.selectedProductData.catentryId]));
        self = this;
        $.each(frameData, function(key,val){
            if(!lensdata.hasOwnProperty(key)) {
                self.selectedProductData[key] = val;
            }
            else{
                /**Selected size value must be of frame value**/
                if(key == "addToBagFlag" || key == "selectedSizeValue" || key == "size" || key == "framePrice" || key == "modelSize" || key == "modelSizeDisplay" || key == "selectedSize") {
                    self.selectedProductData[key] = val;
                }
            }
        });

        self.updateROXPrices();
    };

    this.updateROXPrices = function(){
          self = this;
          var selectedFrame = quickviewRox.selectedProductData.frameCatentryId;
          var frameData = JSON.parse(JSON.stringify(quickviewRox.product[1][selectedFrame]));
          var lensdata  = JSON.parse(JSON.stringify(quickviewRox.product[1][quickviewRox.selectedProductData.catentryId]));
          var framePrice , lensPrice , totalPrice, framePromoPrice, lensPromoPrice, totalPromoPrice = 0;
          if(frameData.hasOwnProperty("unformattedFramePrice") && lensdata.hasOwnProperty("unformattedLensPrice")){
             framePrice = frameData.hasOwnProperty("unformattedFramePrice")? frameData.unformattedFramePrice :0;
             lensPrice  = lensdata.hasOwnProperty("unformattedLensPrice")?lensdata.unformattedLensPrice:0;
             totalPrice = (parseFloat(framePrice) + parseFloat(lensPrice)).toFixed(2);
          }
          if(frameData.hasOwnProperty("unformattedFramePromoPrice") || lensdata.hasOwnProperty("unformattedLensPromoPrice")){
             framePromoPrice = frameData.hasOwnProperty("unformattedFramePromoPrice")? frameData.unformattedFramePromoPrice :frameData.unformattedFramePrice;
             lensPromoPrice  = lensdata.hasOwnProperty("unformattedLensPromoPrice")?lensdata.unformattedLensPromoPrice:lensdata.unformattedLensPrice;
             totalPromoPrice = (parseFloat(framePromoPrice) + parseFloat(lensPromoPrice)).toFixed(2);
          }

          if(totalPromoPrice && totalPrice && totalPrice > totalPromoPrice){
             self.selectedProductData.listPrice = self.currencySymbol ? self.currencySymbol + " "+ totalPrice:totalPrice;
             self.selectedProductData.offerPrice = self.currencySymbol ?self.currencySymbol + " "+totalPromoPrice:totalPromoPrice;
          }
          else if(totalPrice){
             delete self.selectedProductData.listPrice;
             self.selectedProductData.offerPrice = self.currencySymbol ?self.currencySymbol + " "+totalPrice:totalPrice;
          }
    };

    this.callAnalytics = function(product,eventType){
    	var self = this;
    	window.tealium_data2track = window.tealium_data2track || [];
    	var selectedData = {};
    	var data ={};
    	var selectedPartNumber = product.partNumber;
    	var selectedPrice="";
    	if(product.unFormattedPrice !== undefined){
    		selectedPrice = product.unFormattedPrice;
    	}
		data.Category="prescription-sunglasses";
		if("onReady" == eventType || "onFrameChange" == eventType){
			selectedPartNumber =this.product[1][product.frameCatentryId].partNumber;
		}
    	
    	data.Units=1;
    	data.Price=selectedPrice;
    	//logic to derive status of item
    	var status="";
    	if("Y" == product.addToBagFlag){
    		status="Available";
    	}else{
    		if("ACTIVE" == product.lifecycleVal || 
    				undefined === product.lifecycleVal){
    			if(0 === product.buyableqty){
                    if (product.emailLinkFlag === "Y") {
                        status = "out-of-stock-emailme";
                    } else {
                        status = "out-of-stock";
                    }
    			}
    			if(0 < product.buyableqty){
    				status="NotSellable";
    			}
    		}else{
    				status="NotSellable";
    		}
    	}
    	data.Status=status;
    	data.DataSource=product;
    	var eventId ="";
    	selectedData[""+selectedPartNumber]=data;
    	window.tealium_data2track.push({
			id : "WCS-X-QuickViewOverlay-QuickviewProds-Init",
			Products : selectedData
        });
        window.tealium_data2track.push({
        	id : "WCS-D-QuickViewOverlay-Loading-Ready"
        });
    };
};
